import { render, staticRenderFns } from "./OfficialVerification.vue?vue&type=template&id=3f4ce1aa&scoped=true"
import script from "./OfficialVerification.vue?vue&type=script&lang=js"
export * from "./OfficialVerification.vue?vue&type=script&lang=js"
import style0 from "./OfficialVerification.vue?vue&type=style&index=0&id=3f4ce1aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4ce1aa",
  null
  
)

export default component.exports